import axios from '../axios'

/*
 * 打款失败列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/withdrawPayment/selectError',
        method: 'post',
        data
    })
}
export const approveSuccess = (data) => {
    return axios({
        url: '/withdrawApply/approveSuccess',
        method: 'post',
        data
    })
}
export const approveFail = (data) => {
    return axios({
        url: '/withdrawApply/approveFail',
        method: 'post',
        data
    })
}
export const batchRepay = (data) => {
    return axios({
        url: '/withdrawPayment/batchRepay',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/project/batchEnable',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/project/batchDelete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/withdraw/fail.js